/**
 * Versionare & reziliență (spec §5): verifică `/api/version` la focus + interval.
 * - `client.minRequired` > versiunea locală → reload FORȚAT.
 * - `client.latest` > versiunea locală (sau `forceReload`) → banner „Reîncarcă".
 */
import { useEffect, useState } from 'react';
import { compareSemver } from '@reclame-ai/shared';
import { getVersion } from '../api/endpoints';
import { APP_VERSION } from '../lib/version';

export function VersionGate() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    let stopped = false;
    async function check() {
      try {
        const v = await getVersion();
        const client = v.client;
        if (!client) return;
        if (compareSemver(client.minRequired, APP_VERSION) > 0 || client.forceReload) {
          // Reload forțat.
          if (!stopped) window.location.reload();
          return;
        }
        if (compareSemver(client.latest, APP_VERSION) > 0) {
          if (!stopped) setShowBanner(true);
        }
      } catch {
        /* offline — ignoră */
      }
    }
    void check();
    const interval = window.setInterval(check, 5 * 60 * 1000);
    const onFocus = () => void check();
    window.addEventListener('focus', onFocus);
    return () => {
      stopped = true;
      window.clearInterval(interval);
      window.removeEventListener('focus', onFocus);
    };
  }, []);

  if (!showBanner) return null;
  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 400,
        background: 'var(--accent)',
        color: 'var(--accent-ink)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 14,
        padding: '10px 16px',
        fontSize: 13.5,
        fontWeight: 800,
      }}
    >
      <span>A apărut o versiune nouă a aplicației.</span>
      <button
        onClick={() => window.location.reload()}
        style={{ background: 'var(--accent-ink)', color: 'var(--accent)', borderRadius: 999, padding: '6px 14px', fontWeight: 800 }}
      >
        Reîncarcă
      </button>
    </div>
  );
}
